import { immerable } from "immer";
import { CinemaProjector } from "./cinema-projector";
import { DbMongoSerializationBaseInfos } from "./db-mongo-serialization-base-infos";
import { DbObjectCreateOrUpdateInfos } from "./db-object-create-or-update-infos";
import { GlobecastLink } from "./globalcast-link";

export class RecipientContact {
  fullName: string | null = null;
  email: string | null = null;
  phone: string | null = null;
}

export class DbKdmRecipientInfos extends DbMongoSerializationBaseInfos {
  [immerable] = true;
  platformId: number | null = null;
  creationInfos: DbObjectCreateOrUpdateInfos | null = null;
  updateInfos: DbObjectCreateOrUpdateInfos | null = null;
  serialNumber: string | null = null;
  address: string | null = null;
  zipCode: string | null = null;
  city: string | null = null;
  region: string | null = null;
  country: string | null = null;
  name: string | null = null;
  roomName: string | null = null;
  type: KdmRecipientType | null = null;
  theater: string | null = null;
  projector: CinemaProjector | null = null;
  globecast: GlobecastLink | null = null;
  cert: string | null = null;
  contact: RecipientContact | null = null;

  constructor(init?: Partial<DbKdmRecipientInfos>) {
    super();
    Object.assign(this, init);
  }
}

export enum KdmRecipientType {
  TheaterProjector = "TheaterProjector",
  DcpReaderSoftware = "DcpReaderSoftware",
  KdmGenServer = "KdmGenServer",
}

export enum KdmRecipientTheaterCompagny {
  Unknown = "Unknown",
  Pathe = "Pathe",
  Gaumont = "Gaumont",
  CGR = "CGR",
  UGC = "UGC",
  Cineville = "Cineville",
  Kinepolis = "Kinepolis",
  Megarama = "Megarama",
  CGE = "CGE",
  MK2 = "MK2",
}

export enum KdmRecipientProjectorBrand {
  Unknown = "Unknown",
  Dolby = "Dolby",
  Sony = "Sony",
  Christie = "Christie",
  Barco = "Barco",
  NEC = "NEC",
}

export enum KdmRecipientDciServer {
  Unknown = "Unknown",
  DolbyIMS3000 = "DolbyIMS3000",
  Doremi = "Doremi",
  SonySRX = "SonySRX",
}
